<template>
    <div class="container" @contextmenu.prevent>
        <div class="row">
            <van-swipe class="swipe">
                <van-swipe-item class="swipe-item" v-for="image in images" :key="image.id" height="30" lazy-render :stop-propagation="false">
                    <img class="swipe-img" :src="image.res_value" alt="爱驿站"/>
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="info">
            <div class="info-title">
                {{ nickname }}
            </div>
            <div class="info-number">
                <van-space size="1rem">
                    <span>ID</span> <span @click="copyId">{{ userId }} <van-icon name="/ayz_icon/copy.png"/></span>
                </van-space>
            </div>
            <div class="info-detail">
                <van-space size="5px">
                    <span>{{ age }}岁</span> ·
                    <span>{{ sex }}</span> ·
                    <span>{{ height }}cm</span> ·
                    <span>{{ household_reg_city }}</span> |
                    <span>{{ household_reg_county }}</span>
                    <span @click="showPopup"><van-icon name="/ayz_icon/auth.png"/></span>
                </van-space>
            </div>
        </div>
        <!--资料-->
        <div class="tab-box">
            <div class="tab-title">
                资料
            </div>
            <div class="detail">
                <div class="detail-title">
                    <div class="detail-field">学历</div>
                    <div class="detail-value">{{ education }}
                        <span @click="showPopup" v-if="education_verify === 1"><van-icon
                            name="/ayz_icon/auth.png"/></span>
                        <span @click="showPopup" v-else><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">婚姻</div>
                    <div class="detail-value">{{ marriage }}
                        <span @click="showPopup" v-if="marriage_verify === 1"><van-icon
                            name="/ayz_icon/auth.png"/></span>
                        <span @click="showPopup" v-else><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">月收入</div>
                    <div class="detail-value">{{ salary }}
                        <span @click="showPopup" v-if="salary_verify === 1"><van-icon name="/ayz_icon/auth.png"/></span>
                        <span @click="showPopup" v-else><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">体重</div>
                    <div class="detail-value">{{ weight }}
                        <span @click="showPopup"><van-icon name="/ayz_icon/auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">购房情况</div>
                    <div class="detail-value">{{ house }}
                        <span @click="showPopup" v-if="house_verify === 1"><van-icon name="/ayz_icon/auth.png"/></span>
                        <span @click="showPopup" v-else><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">房产价格</div>
                    <div class="detail-value">{{ house_price }}
                        <span @click="showPopup" v-if="house_verify === 1"><van-icon name="/ayz_icon/auth.png"/></span>
                        <span @click="showPopup" v-else><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">购车情况</div>
                    <div class="detail-value">{{ car }}
                        <span @click="showPopup" v-if="car_verify === 1"><van-icon name="/ayz_icon/auth.png"/></span>
                        <span @click="showPopup" v-else><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">车辆价格</div>
                    <div class="detail-value">{{ car_price }}
                        <span @click="showPopup" v-if="car_verify === 1"><van-icon name="/ayz_icon/auth.png"/></span>
                        <span @click="showPopup" v-else><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">是否带孩</div>
                    <div class="detail-value">{{ children_info }}
                        <span @click="showPopup" v-if="children_info_verify === 1"><van-icon name="/ayz_icon/auth.png"/></span>
                        <span @click="showPopup" v-else><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">民族</div>
                    <div class="detail-value">{{ nation }}
                        <span @click="showPopup"><van-icon name="/ayz_icon/auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">独生子女</div>
                    <div class="detail-value">{{ is_only_son }}
                        <span @click="showPopup" v-if="is_only_son_verify === 1"><van-icon name="/ayz_icon/auth.png"/></span>
                        <span @click="showPopup" v-else><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title">
                    <div class="detail-field" v-show="family_show">家庭成员</div>
                    <div class="detail-value">{{ family }}
                        <span @click="showPopup" v-if="family_verify === 1"><van-icon name="/ayz_icon/auth.png"/></span>
                        <span @click="showPopup" v-else><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">职业</div>
                    <div class="detail-value">{{ job }}
                        <span @click="showPopup" v-if="job_verify === 1"><van-icon name="/ayz_icon/auth.png"/></span>
                        <span @click="showPopup" v-else><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">工作地区</div>
                    <div class="detail-value">{{ reside }}
                        <span @click="showPopup"><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title" v-show="work_unit_show">
                    <div class="detail-field">工作单位</div>
                    <div class="detail-value">{{ work_unit }}
                        <span @click="showPopup" v-if="work_unit_verify === 1"><van-icon name="/ayz_icon/auth.png"/></span>
                        <span @click="showPopup" v-else><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title" v-show="nature_of_work_unit_show">
                    <div class="detail-field">单位性质</div>
                    <div class="detail-value">{{ nature_of_work_unit }}
                        <span @click="showPopup"><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title" v-show="health_show">
                    <div class="detail-field">身体状态</div>
                    <div class="detail-value">{{ health }}
                        <span @click="showPopup"><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title" v-show="smoking_show">
                    <div class="detail-field">是否抽烟</div>
                    <div class="detail-value">{{ smoking }}</div>
                </div>
                <div class="detail-title" v-show="drinking_show">
                    <div class="detail-field">是否喝酒</div>
                    <div class="detail-value">{{ drinking }}</div>
                </div>
                <div class="detail-title" v-show="live_with_parent_show">
                    <div class="detail-field">是否愿意与父母同住</div>
                    <div class="detail-value">{{ live_with_parent }}</div>
                </div>
                <div class="detail-title" v-show="cooking_show">
                    <div class="detail-field">是否会做饭</div>
                    <div class="detail-value">{{ cooking }}</div>
                </div>
                <div class="detail-title" v-show="tattoo_show">
                    <div class="detail-field">是否纹身</div>
                    <div class="detail-value">{{ tattoo }}
                        <span @click="showPopup"><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title" v-show="school_show">
                    <div class="detail-field">毕业院校</div>
                    <div class="detail-value">{{ school }}
                        <span @click="showPopup" v-if="school_verify === 1"><van-icon name="/ayz_icon/auth.png"/></span>
                        <span @click="showPopup" v-else><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title" v-show="major_show">
                    <div class="detail-field">专业</div>
                    <div class="detail-value">{{ major }}
                        <span @click="showPopup" v-if="major_verify === 1"><van-icon name="/ayz_icon/auth.png"/></span>
                        <span @click="showPopup" v-else><van-icon name="/ayz_icon/no_auth.png"/></span>
                    </div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">属相</div>
                    <div class="detail-value">{{ zodiac }}</div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">星座</div>
                    <div class="detail-value">{{ constellation }}</div>
                </div>
                <div class="detail-title" v-show="religion_show">
                    <div class="detail-field">宗教信仰</div>
                    <div class="detail-value">{{ religion }}</div>
                </div>
                <div class="detail-title" v-show="bio_show">
                    <div class="detail-field">个人独白</div>
                    <div class="detail-value">{{ bio }}</div>
                </div>
            </div>
        </div>
        <!--择偶条件-->
        <div class="tab-box">
            <div class="tab-title">
                择偶条件
            </div>
            <div class="detail">
                <div class="detail-title" v-show="expect_age_show">
                    <div class="detail-field">年龄</div>
                    <div class="detail-value">{{ expect_age }}</div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">最低学历</div>
                    <div class="detail-value">{{ expect_min_education }}</div>
                </div>
                <div class="detail-title" v-show="expect_height_show">
                    <div class="detail-field">身高</div>
                    <div class="detail-value">{{ expect_height }}</div>
                </div>
                <div class="detail-title" v-show="expect_weight_show">
                    <div class="detail-field">体重</div>
                    <div class="detail-value">{{ expect_weight }}</div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">最低月收入</div>
                    <div class="detail-value">{{ expect_min_salary }}</div>
                </div>
                <div class="detail-title" v-show="expect_marriage_show">
                    <div class="detail-field">婚姻状态</div>
                    <div class="detail-value">{{ expect_marriage }}</div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">购车情况</div>
                    <div class="detail-value">{{ expect_car }}</div>
                </div>
                <div class="detail-title">
                    <div class="detail-field">购房情况</div>
                    <div class="detail-value">{{ expect_house }}</div>
                </div>
                <div class="detail-title" v-show="expect_health_show">
                    <div class="detail-field">身体状况</div>
                    <div class="detail-value">{{ expect_health }}</div>
                </div>
            </div>
        </div>
        <!--兴趣爱好-->
        <div class="tab-box" v-if="hobby.length > 0">
            <div class="tab-title">
                兴趣爱好
            </div>
            <div class="detail" v-for="item in hobby" :key="item.hobby_name">
                <div class="detail-title" v-if="item.hobby_name === 'sport'">
                    <div class="detail-field">喜欢的运动</div>
                    <div class="detail-value">{{ item.hobby_value }}</div>
                </div>
                <div class="detail-title" v-if="item.hobby_name === 'book'">
                    <div class="detail-field">喜欢的书籍</div>
                    <div class="detail-value">{{ item.hobby_value }}</div>
                </div>
                <div class="detail-title" v-if="item.hobby_name === 'singer'">
                    <div class="detail-field">喜欢的歌手</div>
                    <div class="detail-value">{{ item.hobby_value }}</div>
                </div>
                <div class="detail-title" v-if="item.hobby_name === 'movie'">
                    <div class="detail-field">喜欢的电影</div>
                    <div class="detail-value">{{ item.hobby_value }}</div>
                </div>
                <div class="detail-title" v-if="item.hobby_name === 'user_tag'">
                    <div class="detail-field">个人标签</div>
                    <div class="detail-value">{{ item.hobby_value }}</div>
                </div>

            </div>
        </div>
<!--        <div class="footer" @click="goDownLoad">-->
        <div class="footer">
            <div class="footer-img">
                <img src="/ayz_icon/logo.webp" alt="爱驿站">
            </div>
            <div class="footer-text">
                <div>手机应用商店下载爱驿站APP</div>
                <div>查看更多真实、优质会员资料</div>
            </div>
        </div>
    </div>

    <!--认证提示弹窗-->
    <van-popup v-model:show="auth_msg" round :style="{width: '100%' }">
        <div class="auth-msg" style="margin-top: 26px; ">
            <img src="/ayz_icon/auth.png"/>
            <div class="tips_msg">认证标识：此标识信息经爱驿站人工审核完成</div>
        </div>
        <div class="auth-msg">
            <img src="/ayz_icon/no_auth.png"/>
            <div class="tips_msg">未认证标识：此标识信息由用户自填登记，未进行审核验证，请谨慎辨别</div>
        </div>
        <div class="auth-msg" style="margin-left: 35%;width: 100px">
            <van-checkbox v-model="noTips" icon-size="12px" checked-color="#ee0a24">不再提示</van-checkbox>
        </div>
        <div style="margin: 26px;">
            <van-button round block type="default" @click="hidePopup">
                我知道了
            </van-button>
        </div>
    </van-popup>

    <!--回到顶部-->
    <van-back-top class="custom"><img src="/back_top.png"  alt="回到顶部"></van-back-top>
</template>

<script>

import ayzAjax from "@/plugins/axios";
// import {useRoute} from 'vue-router'
import {
    getCarName, getCarPriceName, getCarState, getChildrenState, getCookingName, getDrinkingName,
    getEducationName, getHealthName, getHealthState,
    getHouseName,
    getHousePrice, getHouseState, getLiveWithParentName,
    getMarriageName, getMarriageState, getOnlySonName,
    getSalaryName, getSexName, getSmokingName, getTattooName
} from "@/assets/js/common";
import {showFailToast, showSuccessToast} from "vant";


export default {
    name: "UserView",
    data: function () {
        return {
            images: [],
            userId: 0,
            nickname: '',
            age: '',
            sex: '男',
            height: '',
            household_reg_city: '',
            household_reg_county: '',
            /*资料*/
            education: '',//学历
            marriage: '',//婚姻
            salary: '',//月收入
            weight: '',//体重
            house: '',//购房情况
            house_price: '',//房产价格
            car: '',//购车情况
            car_price: '',//车辆价格
            children_info: '',//是否带孩
            nation: '',//民族
            is_only_son: '',//独生子女
            family: '',//家庭成员
            job: '',//职业
            reside: '',//工作地区
            work_unit: '',//工作单位
            nature_of_work_unit: '',//工作单位性质
            health: '',//身体状态
            smoking: '',//是否抽烟
            drinking: '',//是否喝酒
            live_with_parent: '',//是否愿意与父母同住
            cooking: '',//是否会做饭
            tattoo: '',//是否有纹身
            school: '',//毕业院校
            major: '',//专业
            zodiac: '',//属相
            constellation: '',//星座
            religion: '',//宗教信仰
            bio: '',//个人独白

            /*验证字段认证图标控制*/
            education_verify: 0,
            marriage_verify: 0,
            salary_verify: 0,
            house_verify: 0,
            car_verify: 0,
            children_info_verify: 0,
            is_only_son_verify: 0,
            family_verify: 0,
            job_verify: 0,
            work_unit_verify: 0,
            school_verify: 0,
            major_verify: 0,

            /*资料为空控制是否显示*/
            nature_of_work_unit_show: false,
            work_unit_show: false,
            family_show: false,
            health_show: false,
            smoking_show: false,
            drinking_show: false,
            live_with_parent_show: false,
            cooking_show: false,
            tattoo_show: false,
            school_show: false,
            major_show: false,
            religion_show: false,
            bio_show: false,

            /*择偶条件*/
            expect_age: '',
            expect_min_education: '',
            expect_height: '',
            expect_weight: '',
            expect_min_salary: '',
            expect_marriage: '',
            expect_car: '',
            expect_house: '',
            expect_health: '',
            expect_health_show: false,
            expect_marriage_show: false,
            expect_weight_show: false,
            expect_age_show: false,
            expect_height_show: false,

            /*兴趣爱好*/
            hobby: [],
            /*认证标识提醒页面是否显示*/
            auth_msg: false,
            noTips: false,
        }
    },
    created() {
        this.getProFile();
    },
    methods: {
        getProFile() {
            try {
                ayzAjax.get('/get_profile_info?share_id=' + this.$route.params.share_id).then((response) => {
                    console.log(response.data);
                    if (response.data.code !== 200) {
                        showFailToast(response.data.msg)
                        return false;
                    }

                    /*轮播相册*/
                    this.images = response.data.data.album;

                    this.userId = response.data.data.user.id;
                    this.nickname = response.data.data.user.nickname;

                    /*资料*/
                    this.age = response.data.data.base.age;
                    this.sex = getSexName(response.data.data.base.sex);
                    this.height = response.data.data.base.height;
                    this.household_reg_city = response.data.data.base.household_reg_city;
                    this.household_reg_county = response.data.data.base.household_reg_county;

                    this.education = getEducationName(response.data.data.base.education);
                    this.education_verify = response.data.data.auth.education;
                    this.marriage = getMarriageName(response.data.data.base.marriage);
                    this.marriage_verify = response.data.data.auth.marriage;
                    this.salary = getSalaryName(response.data.data.base.salary);
                    this.salary_verify = response.data.data.auth.salary;
                    this.weight = response.data.data.base.weight + 'kg';
                    this.house = getHouseName(response.data.data.base.house);
                    // console.log(response.data.data.base.house,this.house)
                    this.house_price = getHousePrice(response.data.data.base.house_price);
                    this.house_verify = response.data.data.auth.house;
                    this.car = getCarName(response.data.data.base.car);
                    this.car_price = getCarPriceName(response.data.data.base.car_price);
                    this.car_verify = response.data.data.auth.car;
                    this.children_info = getChildrenState(response.data.data.base.children_info);
                    this.children_info_verify = response.data.data.auth.children_info;
                    this.nation = response.data.data.base.nation;
                    this.is_only_son = getOnlySonName(response.data.data.base.is_only_son);
                    this.is_only_son_verify = response.data.data.auth.is_only_son;
                    if (response.data.data.base.family != null && response.data.data.base.family.length >= 1) {
                        this.family = response.data.data.base.family;
                        this.family_verify = response.data.data.auth.family;
                        this.family_show = true;
                    }
                    this.job = response.data.data.base.job;
                    this.job_verify = response.data.data.auth.job;
                    this.reside = `${response.data.data.base.reside_province} ${response.data.data.base.reside_city} ${response.data.data.base.reside_county}`;

                    if (response.data.data.base.work_unit != null && response.data.data.base.work_unit.length >= 1){
                        this.work_unit = response.data.data.base.work_unit;
                        this.work_unit_show = true;
                    }

                    if (response.data.data.base.nature_of_work_unit != null && response.data.data.base.nature_of_work_unit.length >= 1) {
                        this.nature_of_work_unit = response.data.data.base.nature_of_work_unit;
                        this.work_unit_verify = response.data.data.auth.work_unit;
                        this.nature_of_work_unit_show = true;
                    }
                    if (response.data.data.base.health != null && response.data.data.base.health > 0) {
                        this.health = getHealthName(response.data.data.base.health);
                        this.health_show = true;
                    }
                    if (response.data.data.base.smoking != null && response.data.data.base.smoking > 0) {
                        this.smoking = getSmokingName(response.data.data.base.smoking);
                        this.smoking_show = true;
                    }
                    if (response.data.data.base.drinking != null && response.data.data.base.drinking > 0) {
                        this.drinking = getDrinkingName(response.data.data.base.drinking);
                        this.drinking_show = true;
                    }
                    if (response.data.data.base.live_with_parent != null && response.data.data.base.live_with_parent > 0) {
                        this.live_with_parent = getLiveWithParentName(response.data.data.base.live_with_parent);
                        this.live_with_parent_show = true;
                    }
                    if (response.data.data.base.cooking != null && response.data.data.base.cooking > 0) {
                        this.cooking = getCookingName(response.data.data.base.cooking);
                        this.cooking_show = true;
                    }
                    if (response.data.data.base.tattoo != null && response.data.data.base.tattoo > 0) {
                        this.tattoo = getTattooName(response.data.data.base.tattoo);
                        this.tattoo_show = true;
                    }
                    if (response.data.data.base.school != null && response.data.data.base.school.length >= 1) {
                        this.school = response.data.data.base.school;
                        this.school_verify = response.data.data.auth.school;
                        this.school_show = true;
                    }
                    if (response.data.data.base.major != null && response.data.data.base.major.length >= 1) {
                        this.major = response.data.data.base.major;
                        this.major_verify = response.data.data.auth.major;
                        this.major_show = true;
                    }
                    this.zodiac = response.data.data.base.zodiac;
                    this.constellation = response.data.data.base.constellation;
                    if (response.data.data.base.religion != null && response.data.data.base.religion.length >= 1) {
                        this.religion = response.data.data.base.religion;
                        this.religion_show = true;
                    }
                    if (response.data.data.base.bio != null && response.data.data.base.bio.length >= 1) {
                        this.bio = response.data.data.base.bio;
                        this.bio_show = true;
                    }
                    /*择偶条件*/
                    if (response.data.data.condition.expect_min_age != null && response.data.data.condition.expect_min_age > 0){
                        this.expect_age = `${response.data.data.condition.expect_min_age} - ${response.data.data.condition.expect_max_age} 岁`;
                        this.expect_age_show = true;
                    }

                    this.expect_min_education = getEducationName(response.data.data.condition.expect_min_education);

                    if (response.data.data.condition.expect_height != null && response.data.data.condition.expect_height > 0){
                        this.expect_height = `${response.data.data.condition.expect_min_height} - ${response.data.data.condition.expect_max_height} cm`;
                        this.expect_height_show = true;
                    }

                    if (response.data.data.condition.expect_min_weight != null && response.data.data.condition.expect_min_weight > 0) {
                        this.expect_weight = `${response.data.data.condition.expect_min_weight} - ${response.data.data.condition.expect_max_weight} kg`;
                        this.expect_weight_show = true;
                    }
                    this.expect_min_salary = getSalaryName(response.data.data.condition.expect_min_salary);
                    this.expect_car = getCarState(response.data.data.condition.expect_car);
                    this.expect_house = getHouseState(response.data.data.condition.expect_house);

                    if (response.data.data.condition.expect_health != null && response.data.data.condition.expect_health > 0) {
                        this.expect_health = getHealthState(response.data.data.condition.expect_health);
                        this.expect_health_show = true;
                    }
                    if (response.data.data.condition.expect_marriage != null && response.data.data.condition.expect_marriage > 0) {
                        this.expect_marriage = getMarriageState(response.data.data.condition.expect_marriage);
                        this.expect_marriage_show = true;
                    }
                    /*兴趣爱好*/
                    this.hobby = response.data.data.hobby;

                })
            } catch (err) {

                showFailToast('网络错误,请稍后再试!')
            }
        },
        showPopup() {
            if (this.noTips === false) {
                this.auth_msg = true;
            }
        },
        hidePopup() {
            this.auth_msg = false;
        },
        copyId() {
            const text = this.userId;
            const el = document.createElement('textarea');
            el.value = text;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            showSuccessToast('用户ID已复制');
        },
        goDownLoad(){
            this.$router.push({ path: '/download' });
        },
    }
}
</script>


<style scoped lang="scss">
.container {
    background: #F8F8F8;
    padding: 10px;
}

.row {
    //display: flex;
    flex-wrap: wrap;
    background: #fff;
    width: 100%;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    .swipe{
        width: 100%;
        .swipe-item {
            text-align: center;
            border-top-left-radius: 20px;
            border-top-right-radius: 20px;
        }
    }
}
.swipe{
    width: 100%;
    height: 360px;
    overflow: hidden; /* 超出部分隐藏 */
    .swipe-img {
        width: 100%;
        height: auto;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
    }
}

.info {
    width: 100%;
    text-align: left;
    //height: 200px;
    background: #fff;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    font-size: 14px;
}

.info-title {
    width: 100%;
    height: 70px;
    line-height: 70px;
    padding-left: 20px;
    font-weight: 500;
    font-size: 22px;
    color: #161615;
}

.info-number {
    width: 100%;
    height: 40px;
    padding-left: 20px;
    color: #333333;
}

.info-detail {
    width: 100%;
    height: 40px;
    padding-left: 20px;
    color: #333333;
}

.tab-box {
    margin-top: 10px;
    padding-top: 20px;
    padding-bottom: 20px;
    width: 100%;
    min-height: 300px;
    background: #fff;
    border-radius: 20px;
    text-align: left;
}

.tab-title {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    font-weight: 500;
    font-size: 16px;
    color: #161615;

}

.detail-title {
    display: flex;
    margin-top: 25px;
    margin-left: 20px;
    .detail-field {
        font-size: 14px;
        width: 100px;
        color: #888888;
        font-weight: 400;
    }

    .detail-value {
        font-size: 14px;
        color: #222222;
        font-weight: 400;
        width: 200px;
    }
}
.auth-msg {
    text-align: left;
    margin-top: 20px;
    margin-left: 50px;
    line-height: 20px;
    color: #000000;
    font-size: 12px;
    .tips_msg {
        color: #888888;
        font-weight: 300;
        font-size: 14px;
        width: 250px;
    }
}

.footer{
    display: flex;
    margin-top: 10px;
    padding-top: 20px;
    padding-bottom: 20px;
    width: 100%;
    min-height: 66px;
    background: #fff;
    border-radius: 20px;
    text-align: left;

    .footer-img{
        margin-left: 20px;
        width: 66px;
        height: 66px;
        img{
            width: 66px;
            height: 66px;
        }
    }
    .footer-text{
        font-weight: 400;
        font-size: 13px;
        color: #777777;
        margin-left: 20px;
        //line-height: 15px;
        div{
            margin-top: 10px;
        }
    }
}
.van-icon{
    top: 2px;
}
.custom{
    width: 50px;
    height: 50px;
    img{
        width: 50px;
        height: 50px;
    }
}

</style>